/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UserNotificationData } from './UserNotificationData'
import {
  UserNotificationDataFromJSON,
  UserNotificationDataFromJSONTyped,
  UserNotificationDataToJSON,
} from './UserNotificationData'

/**
 * Уведомление пользователя
 * @export
 * @interface UserNotification
 */
export interface UserNotification {
  /**
   * UUID уведомления
   * @type {string}
   * @memberof UserNotification
   */
  id: string
  /**
   * Полезная нагрузка уведомления (набор ключей зависит от типа нотификации)
   * @type {UserNotificationData}
   * @memberof UserNotification
   */
  data: UserNotificationData
  /**
   * Время прочтения (формат Y-m-d H:i)
   * @type {string}
   * @memberof UserNotification
   */
  readAt: string | null
  /**
   * Время создания (формат Y-m-d H:i)
   * @type {string}
   * @memberof UserNotification
   */
  createdAt: string | null
}

/**
 * Check if a given object implements the UserNotification interface.
 */
export function instanceOfUserNotification(
  value: object
): value is UserNotification {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  if (!('readAt' in value) || value['readAt'] === undefined) return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  return true
}

export function UserNotificationFromJSON(json: any): UserNotification {
  return UserNotificationFromJSONTyped(json, false)
}

export function UserNotificationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserNotification {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    data: UserNotificationDataFromJSON(json['data']),
    readAt: json['readAt'],
    createdAt: json['createdAt'],
  }
}

export function UserNotificationToJSON(value?: UserNotification | null): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    data: UserNotificationDataToJSON(value['data']),
    readAt: value['readAt'],
    createdAt: value['createdAt'],
  }
}
